import { render, staticRenderFns } from "./AdminExcludedReferralsComponent.vue?vue&type=template&id=3ed06832"
import script from "./AdminExcludedReferralsComponent.vue?vue&type=script&lang=js"
export * from "./AdminExcludedReferralsComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminExcludedReferralsComponent.vue?vue&type=style&index=0&id=3ed06832&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports